import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#0c5c7e',
        background: '#f7f7f7',
        secondary: '#37474F',
        tertiary: '#98B815',
        accent: '#8c9eff',
        error: '#b71c1c'
      }
    }
  }
})
